import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useDynamicOtpHook = (NoOfFields) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const otpLength = NoOfFields;

  // Keep refs in a single useRef
  const inputRefs = useRef([]);

  // OTP state as array
  const [pin, setPin] = useState(Array(otpLength).fill(''));

  // Reset OTP when length changes
  useEffect(() => {
    setPin(Array(otpLength).fill(''));
    inputRefs.current = Array(otpLength).fill(null);
  }, [otpLength]);

  const handleChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const updatedOTP = [...pin];
      updatedOTP[index] = value;
      setPin(updatedOTP);

      // Move to next input
      if (value !== '' && index < otpLength - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyUp = (index, event) => {
    if (event.key === 'Backspace') {
      if (pin[index] === '' && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  return {
    handleChange,
    handleKeyUp,
    pin,
    inputRefs,
  };
};

export default useDynamicOtpHook;